import {updateLessonImage} from "api/services/lesson-service";
import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";

export const useUpdateLessonImage = () => {
    const { callAPI, loading } = useWorkspaceApiCall(updateLessonImage, '', 'updateLessonImage.error');

    return { updateLessonImage: callAPI, updateLessonImagePending: loading };
}
